import React from 'react';

export type DatePickerContextType = {
  currentDate: Date;
  setCurrentDate: (_: Date) => void;
  setHeaderSize: (size: { width?: number; height?: number }) => void;
  headerSize?: { width?: number; height?: number };
};

export const DatePickerContext = React.createContext<DatePickerContextType>(
  {} as DatePickerContextType,
);

export const DatePickerConsumer = DatePickerContext.Consumer;
export const DatePickerProvider = DatePickerContext.Provider;

export const useDatePicker = () => React.useContext(DatePickerContext);
